export const LValorPercentual = [
  { key: 0, text: "Valor" },
  { key: 1, text: "Percentual" },
];
